import axios from 'axios';
import { postData } from '../../services/axiosUtils';

const asListResponse = (data: any) => {
  if (Array.isArray(data)) {
    return { hasError: false, records: data, errorMessages: [] };
  }
  if (data?.records) {
    return data;
  }
  return { hasError: false, records: data ? [data] : [], errorMessages: [] };
};

const wrapMutation = (response: any) =>
  response?.hasError !== undefined ? response : { hasError: false, result: response };

const subscriptionService = {
  list: () => axios.get(`/api/subscriptions/list`).then((response) => asListResponse(response.data)),
  get: (id: any) =>
    axios.get(`/api/subscriptions/details/${id}`).then((response) =>
      response.data?.hasError !== undefined
        ? response.data
        : { hasError: false, result: response.data, errorMessages: [] }
    ),
  create: (entity: any) =>
    postData({ url: `/api/subscriptions/create`, data: entity }).then(wrapMutation),
  update: (entity: any) =>
    postData({ url: `/api/subscriptions/update`, data: entity, method: 'PUT' }).then(wrapMutation),
  delete: (id: any) =>
    postData({ url: `/api/subscriptions/delete/${id}`, method: 'DELETE' }).then(wrapMutation),
};

export default subscriptionService;
